<template>
  <el-card
    shadow="always"
    :body-style="{ padding: '20px' }"
    v-loading="loading"
  >
    <div slot="header">
      <div>
        <span>
          <el-radio-group v-model="currentQueryType" size="medium">
            <el-radio-button
              v-for="template in queryTemplates.filter(
                template => template.level >= session.type
              )"
              :key="template.type"
              :label="template.type"
              >{{ template.title }}</el-radio-button
            >
          </el-radio-group>
        </span>
        <el-button
          type="success"
          size="medium"
          @click="$router.push({ name: 'LedgerAdd' })"
          style="float: right; margin: 3px 3px"
          >Создать</el-button
        >
        <el-button
          type="primary"
          size="medium"
          @click="performSearch"
          style="float: right; margin: 3px 3px"
          icon="el-icon-refresh"
          >Обновить</el-button
        >
        <el-popover placement="bottom" width="500" trigger="click">
          <div v-loading="csvLoading">
            <el-row :gutter="20">
              <el-col :span="24" :offset="0">
                <a href="#" @click.prevent="getCsv()">За все время</a>
                <a
                  href="#"
                  @click.prevent="
                    getCsv({
                      dateStart: {
                        $gte: $dayjs().startOf('day')
                      }
                    })
                  "
                  >За сегодня</a
                >
                <a
                  href="#"
                  @click.prevent="
                    getCsv({
                      dateStart: {
                        $gte: $dayjs().startOf('week')
                      }
                    })
                  "
                  >За эту неделю</a
                >
                <a
                  href="#"
                  @click.prevent="
                    getCsv({
                      dateStart: {
                        $gte: $dayjs().startOf('month')
                      }
                    })
                  "
                  >За этот месяц</a
                >
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="20" :offset="0">
                <el-date-picker
                  v-model="csvDateRange"
                  type="datetimerange"
                  align="right"
                  start-placeholder="От"
                  end-placeholder="До"
                  :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
              </el-col>
              <el-col :span="4" :offset="0">
                <el-button
                  type="primary"
                  icon="el-icon-download"
                  @click="
                    getCsv(
                      csvDateRange
                        ? {
                            dateStart: {
                              $lte: $dayjs(csvDateRange[1]),
                              $gte: $dayjs(csvDateRange[0])
                            }
                          }
                        : {}
                    )
                  "
                ></el-button>
              </el-col>
            </el-row>
          </div>
          <el-button
            slot="reference"
            size="medium"
            :loading="csvLoading"
            style="float: right; margin: 3px 3px"
            icon="el-icon-download"
            >CSV</el-button
          >
        </el-popover>

        <el-button
          size="medium"
          @click="getCsvRates"
          :loading="csvRatesLoading"
          style="float: right; margin: 3px 3px"
          icon="el-icon-download"
          >Курсы</el-button
        >
      </div>
      <div style="margin-top: 20px">
        <ExchangesFilterForm />
      </div>
    </div>
    <el-pagination
      @current-change="handleExchangesPage"
      @size-change="handleExchangesLimit"
      :current-page.sync="ledgerExchanges.page"
      :page-size="ledgerExchanges.limit"
      layout="sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 30, 50, 100, 200]"
      :total="ledgerExchanges.totalDocs"
    >
    </el-pagination>
    <!-- card body -->
    <el-table
      :data="ledgerExchangesTableData"
      style="width: 100%"
      :row-class-name="tableRowClassName"
      @sort-change="handleSortChange"
      :default-sort="{ prop: 'dateStart', order: 'descending' }"
      size="mini"
      border
    >
      <el-table-column
        sortable="custom"
        prop="_id"
        label="ID"
        maxwidth="50"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          <span class="copyme" @click="doCopy(scope.row._id)">
            {{ scope.row._id.slice(-6) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="dateStart"
        label="Дата и время создания заявки"
        width="120"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          {{ formatDT(scope.row.dateStart).date }}
          <hr />
          {{ formatDT(scope.row.dateStart).time }}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="updatedAt"
        label="Дата и время изменения сделки"
        width="120"
        label-class-name="wrap"
      >
        <!-- <template slot="header" v-slot="scope">
          Дата и время изменения сделки
        </template> -->
        <template v-slot="scope">
          {{
            formatDT(scope.row.updatedAt) && formatDT(scope.row.updatedAt).date
          }}
          <hr />
          {{ formatDT(scope.row.updatedAt).time }}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="dateEnd"
        label="Открыта/Закрыта"
        width="90"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          <div :class="{ opn: !scope.row.dateEnd }">
            {{ scope.row.dateEnd ? "Закрыта" : "Открыта" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="creator"
        label="Оператор"
        width="120"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          {{ scope.row.creator ? scope.row.creator.login : "" }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="currentQueryType !== 'internal'"
        sortable="custom"
        prop="userName"
        label="Никнейм клиента, номер сделки, ссылка на его профиль"
        width="150"
        label-class-name="wrap"
      >
      </el-table-column>
      <el-table-column
        v-if="currentQueryType !== 'internal'"
        sortable="custom"
        prop="category"
        label="Категория"
        width="150"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          {{ getCategories(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="sourceType"
        label="Тип"
        width="120"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          {{ getSourceTypeTitle(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="currentQueryType !== 'internal'"
        sortable="custom"
        prop="sourceChannel"
        label="Проект"
        width="120"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          {{ getProjectTitle(scope.row) }}
        </template>
      </el-table-column>

      <el-table-column
        label="Кол-во поступивших средств и их вид"
        width="160"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          <el-row
            v-for="intr in Object.entries(getInTransaction(scope.row))"
            :gutter="20"
            :key="intr[0]"
            class="striped"
          >
            <el-col :span="12" :offset="0" class="colleft">
              {{ intr[1].amount }}
            </el-col>
            <el-col :span="12" :offset="0" class="colright">
              {{ intr[0] }}
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column
        label="Кол-во отправленных средств и их вид"
        width="160"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          <el-row
            v-for="outtr in Object.entries(getOutTransaction(scope.row))"
            :gutter="20"
            :key="outtr[0]"
            class="striped"
          >
            <el-col :span="12" :offset="0" class="colleft">
              {{ outtr[1].amount }}
            </el-col>
            <el-col :span="12" :offset="0" class="colright">
              {{ outtr[0] }}
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column
        label="Баланс на который пришли средства к нам"
        width="180"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          <el-row
            v-for="intr in Object.entries(getInTransaction(scope.row))"
            :gutter="20"
            :key="intr[0]"
            class="striped"
          >
            <el-col
              :span="24"
              :offset="0"
              :style="{
                background: intr[1].isDeleted
                  ? 'linear-gradient(to right, rgba(223, 171, 171, 0.589), transparent 50%)'
                  : 'initial',
                textDecoration: intr[1].isDeleted ? 'line-through' : 'initial'
              }"
            >
              {{ intr[1].balanceAccount }}
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column
        label="Баланс с которого ушли средства"
        width="180"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          <el-row
            v-for="outtr in Object.entries(getOutTransaction(scope.row))"
            :gutter="20"
            :key="outtr[0]"
            class="striped"
          >
            <el-col
              :span="24"
              :offset="0"
              :style="{
                background: outtr[1].isDeleted
                  ? 'linear-gradient(to right, rgba(223, 171, 171, 0.589), transparent 50%)'
                  : 'initial',
                textDecoration: outtr[1].isDeleted ? 'line-through' : 'initial'
              }"
            >
              {{ outtr[1].balanceAccount }}
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="profit"
        label="Прибыль, %"
        label-class-name="wrap"
        min-width="110"
      >
        <template v-slot="scope">
          {{ scope.row.profit ? (scope.row.profit * 100).toFixed(2) : "N/A" }} %
          <!-- <template  v-if="scope.row.rateFromExchanges && scope.row.rateInternal">
            <span v-if="scope.row.rateInternal.status">
              {{
                Math.round(
                  (((scope.row.rateInternal.outinRate - scope.row.rateFromExchanges.outinRate) /
                    scope.row.rateFromExchanges.outinRate) *
                    100 +
                    Number.EPSILON) *
                    100
                ) / 100
              }}%
            </span>
          </template> -->
        </template>
      </el-table-column>
      <el-table-column
        label="Комментарий к сделке"
        label-class-name="wrap"
        min-width="120"
      >
        <template v-slot="scope">
          {{ scope.row.comment }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="Действия" width="150">
        <template v-slot="scope">
          <el-tooltip v-if="!scope.row.dateEnd" placement="top">
            <div slot="content">Редактировать</div>
            <el-button
              size="small"
              icon="el-icon-edit"
              @click="
                $router.push({
                  name: 'LedgerEdit',
                  params: { id: scope.row.id }
                })
              "
            ></el-button>
          </el-tooltip>
          <!-- <el-button size="small" icon="el-icon-edit"></el-button> -->
          <el-tooltip v-if="scope.row.dateEnd" placement="top">
            <div slot="content">Просмотреть</div>
            <el-button
              size="small"
              icon="el-icon-search"
              @click="
                $router.push({
                  name: 'LedgerEdit',
                  params: { id: scope.row.id }
                })
              "
            ></el-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">Просмотреть полную историю</div>
            <el-button
              size="small"
              icon="el-icon-s-order"
              @click="
                $router.push({
                  name: 'LedgerFull',
                  params: { id: scope.row.id }
                })
              "
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleExchangesPage"
      @size-change="handleExchangesLimit"
      :current-page.sync="ledgerExchanges.page"
      :page-size="ledgerExchanges.limit"
      layout="sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 30, 50, 100, 200]"
      :total="ledgerExchanges.totalDocs"
    >
    </el-pagination>
  </el-card>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {
  getLedgerExchangesCsv,
  getRatesCsv,
  getSourceTypes,
  getProjects
} from "@/api";
import categories from "../../categories";

import ExchangesFilterForm from "../../../../ui/ExchangesFiltersForm.vue";

export default {
  name: "LedgerExchangesComponent",
  data: () => ({
    csvLoading: false,
    csvRatesLoading: false,
    categories,
    csvDateRange: null,
    sourceTypes: [],
    projects: []
  }),
  components: {
    ExchangesFilterForm
  },
  computed: {
    ...mapState("ledgerExchanges", [
      "ledgerExchanges",
      "loading",
      "queryTemplates",
      "queryType"
    ]),
    ...mapState("valutes", ["valutes"]),
    ...mapState("auth", ["session"]),
    currentQueryType: {
      get() {
        return this.queryType;
      },
      set(val) {
        this.changeQueryType({ queryType: val });
      }
    },
    ledgerExchangesTableData() {
      if (this.ledgerExchanges && this.ledgerExchanges.docs) {
        return this.ledgerExchanges.docs.map(exchange => {
          return {
            ...exchange,
            transactions: exchange.ledgerTransactions.length,
            id: exchange._id
          };
        });
      }
      return [];
    }
  },
  methods: {
    ...mapActions("ledgerExchanges", [
      "getLedgerExchanges",
      "goToPage",
      "changeSorting",
      "changeLimit",
      "changeQueryType",
      "addLedgerExchange",
      "performSearch"
    ]),
    ...mapActions("valutes", ["getValutes", "getSortedValutesWithoutForms"]),
    async doCopy(text) {
      try {
        await this.$copyText(text);
        this.$message({
          type: "success",
          message: `Скопировано в буфер обмена`
        });
      } catch (error) {
        this.$message({
          type: "error",
          message: `Не удалось скопировать в буфер обмена`
        });
      }
    },
    async getSourceType() {
      try {
        const { data } = await getSourceTypes({
          page: this.page,
          limit: this.limit,
          sort: this.sort
        });
        if (data.status) {
          this.sourceTypes = data.result.docs;
        }
      } catch (error) {
        console.error("Error fetching sourcetypes:", error);
      }
    },
    getSourceTypeTitle(ex) {
      const src = this.sourceTypes.find(s => s.sourceType === ex.sourceType);
      if (!src) return "Unknown";
      return src.title;
    },
    async getProject() {
      try {
        const { data } = await getProjects({
          page: this.page,
          limit: this.limit,
          sort: this.sort
        });
        if (data.status) {
          this.projects = data.result.docs;
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    },
    getProjectTitle(ex) {
      const src = this.sourceTypes.find(s => s.sourceType === ex.sourceType);
      if (!src || !ex.sourceChannel) {
        return "Unknown";
      }
      const sourceProject = this.projects.find(
        o => o.value === ex.sourceChannel
      );
      return sourceProject ? sourceProject["name"] : ex.sourceChannel;
    },

    getCategories(ex) {
      const cat = categories.find(o => o.value === ex.category);
      return cat ? cat["name"] : "";
    },

    async getCsv(query = {}) {
      try {
        this.csvLoading = true;
        // const query = { dateStart: { $gte: "2022-11-22", $lte: "2022-11-31" } };
        const { data } = await getLedgerExchangesCsv({
          pagination: false,
          query
        });
        const fileURL = window.URL.createObjectURL(new Blob([data]));
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `exchanges_${this.$dayjs().format("DD_MM_YYYY_HH_mm_ss")}.csv`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.csvLoading = false;
      }
    },
    async getCsvRates() {
      try {
        this.csvRatesLoading = true;
        const { data } = await getRatesCsv({ pagination: false });
        const fileURL = window.URL.createObjectURL(new Blob([data]));
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `rates_${this.$dayjs().format("DD_MM_YYYY_HH_mm_ss")}.csv`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.csvRatesLoading = false;
      }
    },
    async handleSortChange(sortData) {
      const sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
          ? `-${sortData.prop}`
          : "";
      await this.changeSorting({ sort });
    },
    handleExchangesPage(page) {
      this.goToPage({ page });
    },
    handleExchangesLimit(limit) {
      this.changeLimit({ limit });
    },
    tableRowClassName({ row, rowIndex }) {
      if (!row.dateEnd) {
        return "warning-row";
      }
      return "";
    },
    dateFormatter(row, column, cellValue, index) {
      if (!cellValue) return undefined;
      return this.$dayjs(cellValue).format("YYYY-MM-DD");
    },
    formatDT(dt) {
      if (!dt) return undefined;
      return {
        date: this.$dayjs(dt).format("YYYY-MM-DD"),
        time: this.$dayjs(dt).format("HH:mm")
      };
    },
    getInTransaction(item) {
      const ret = item.ledgerTransactions
        .filter(item => !item.isHidden && !item.isRevert)
        .reduce((prev, curr) => {
          if (["in"].includes(curr.direction)) {
            if (!curr.balanceAccount || !curr.balanceAccount.valute)
              return { ...prev };
            return {
              ...prev,
              [curr.balanceAccount.valute.name]: {
                amount: parseFloat(
                  (
                    (prev[curr.balanceAccount.valute.name] &&
                    prev[curr.balanceAccount.valute.name].amount
                      ? prev[curr.balanceAccount.valute.name].amount
                      : 0) + curr.amount
                  ).toFixed(12)
                ),
                balanceAccount: curr.balanceAccount.title,
                isDeleted: curr.balanceAccount.isDeleted
              }
            };
          } else {
            return { ...prev };
          }
        }, {});
      return ret;
      // return item.ledgerTransactions.find(t =>
      //   ["in", "deposit_in"].includes(t.direction)
      // );
    },
    getOutTransaction(item) {
      const ret = item.ledgerTransactions
        .filter(item => !item.isHidden && !item.isRevert)
        .reduce((prev, curr) => {
          if (["out"].includes(curr.direction)) {
            if (!curr.balanceAccount || !curr.balanceAccount.valute)
              return { ...prev };
            return {
              ...prev,
              [curr.balanceAccount.valute.name]: {
                amount: parseFloat(
                  (
                    (prev[curr.balanceAccount.valute.name] &&
                    prev[curr.balanceAccount.valute.name].amount
                      ? prev[curr.balanceAccount.valute.name].amount
                      : 0) + curr.amount
                  ).toFixed(12)
                ),
                balanceAccount: curr.balanceAccount.title,
                isDeleted: curr.balanceAccount.isDeleted
              }
            };
          } else {
            return { ...prev };
          }
        }, {});
      return ret;
      // return item.ledgerTransactions.find(t =>
      //   ["out", "deposit_out"].includes(t.direction)
      // );
    }
  },
  async mounted() {
    if (!this.valutes.length) await this.getSortedValutesWithoutForms();
    await this.getLedgerExchanges(), this.getSourceType(), this.getProject();
  }
};
</script>
<style>
hr {
  border-top: 1px solid #c0c4cc;
}

.cell {
  margin-left: 4px;
  margin-right: 4px;
}

.cell .striped {
  border-bottom: 1px solid #c0c4cc;
}

.cell .striped:last-of-type {
  border-bottom: none;
}

.colleft {
  border-right: 1px solid #c0c4cc;
  text-align: center;
}

.colright {
  /* border-left: 1px solid #c0c4cc; */
  text-align: center;
}

.el-table .wrap {
  word-break: break-word;
}

.el-table .warning-row {
  /* background: linear-gradient(
    to right,
    rgba(223, 171, 171, 0.589),
    transparent 20%
  ); */
}

.opn {
  background: linear-gradient(
    to right,
    rgba(223, 171, 171, 0.589),
    transparent 100%
  );
}

.el-table .success-row {
  background: #f0f9eb;
}

.copyme {
  text-decoration: underline dashed;
  cursor: copy;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/Exchanges/index.vue